import { ELYXCentralStore, SubscriptionStore } from "../ELYXStore";
import { loadStripe } from "@stripe/stripe-js";
import SubscriptionAPI from "./SubscriptionAPI";
import store from "../../store/index";
import SettingsMethods from "../Settings/SettingsMethods";
import ELYXConstants from "../ELYXConstants";
const AuthStore = store.state.auth; // !!! AuthStore.user IS NOT AVAILABLE HERE, THAT IS WHY WE GET AUTHSTORE ONLY
let stripe = null;

const stripeProductionKey = "pk_live_51JJWUuIZd2YKFOBk3BytGmXmQ6b3MWC1LpiOV605wRFoqKaiTsEwfwuGn6y5h5JnrsS4K47AHXGZ3fPNx78RIRSu00Pls9hJa4";
const stripeDevelopmentKey = "pk_test_51JJWUuIZd2YKFOBknVMsUkQzgbrXp6HmyLQMYuDecooeHCEqDVC6rlEHAdqyhGmucbNHW2S7xbiEm04wjFFtdcdE002zBIs3XT";

const SubscriptionMethods = {
  openSubscriptionModal(loc = "Unknown") {
    window.mixpanel.track(`Subscription Modal Opened From ${loc}`, {
      UID: AuthStore.user._id,
      data: {
        userAgent: navigator.userAgent,
      },
      page: window.location.href,
    });
    ELYXCentralStore.methods.setModal(ELYXConstants.modals.SubscriptionModal);
  },

  closeSubscriptionModal() {
    SettingsMethods.closeSettingsModal();
    SubscriptionStore.methods.setReachedMaxFreeSessions(false);
  },

  async initStripe() {
    const key = process.env.NODE_ENV === "production" ? stripeProductionKey : stripeDevelopmentKey;
    stripe = await loadStripe(key);
  },

  async createCheckoutSession(priceID) {
    const referralID = window.FPROM && window.FPROM.data.tid ? window.FPROM.data.tid : null;
    const response = await SubscriptionAPI.createCheckoutSession(AuthStore.user._id, priceID, referralID);
    if (!response || !response.success || !response.data || !response.data.stripeSessionID) {
      throw new Error("Failed to create checkout session.");
    }

    const result = await stripe.redirectToCheckout({
      sessionId: response.data.stripeSessionID,
    });

    if (result.error) {
      // Show an error message to the user.
      console.log("ERROR: ", result.error.message);
    }
  },

  async manageStripeSubscription() {
    /** Create a Stripe Portal Session for the customer and returns an URL to the portal. */
    const response = await SubscriptionAPI.createPortalSession(AuthStore.user._id);
    if (!response || !response.success || !response.data || !response.data.stripePortalURL) {
      throw new Error("Failed to create checkout session.");
    }
    window.location.href = response.data.stripePortalURL;
  },
};

export default SubscriptionMethods;
